// extracted by mini-css-extract-plugin
export default {"root":"PageFatherE_root__OGfqN","inner":"PageFatherE_inner__ILoBD","content":"PageFatherE_content__EMlSz","back":"PageFatherE_back__eamxl"};